import { PanelDetailForm } from "../components/panels/PanelDetailForm";
import { Section } from "../components/Section";

export function NewPanelPage() {
  return (
    <div className="flex flex-col flex-1 max-w-3xl">
      <Section.Title>New panel</Section.Title>
      <PanelDetailForm />
    </div>
  );
}
